import { NgClass, isPlatformBrowser } from '@angular/common';
import {
  Component,
  ViewEncapsulation,
  HostListener,
  OnInit,
  Inject,
  PLATFORM_ID
} from '@angular/core';

@Component({
  selector: 'app-back-to-the-top-button',
  templateUrl: './back-to-the-top-button.component.html',
  styleUrls: ['./back-to-the-top-button.component.scss'],
  standalone: true,
  imports: [NgClass],
  encapsulation: ViewEncapsulation.None
})
export class BackToTheTopButtonComponent implements OnInit {
  windowScrolled: boolean;

  constructor(@Inject(PLATFORM_ID) private platformId: any) {}

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (isPlatformBrowser(this.platformId)) {
      if (
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop > 100
      ) {
        this.windowScrolled = true;
      } else if (
        (this.windowScrolled && window.pageYOffset) ||
        document.documentElement.scrollTop ||
        document.body.scrollTop < 10
      ) {
        this.windowScrolled = false;
      }
    }
  }

  scrollToTop() {
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  ngOnInit() {}
}
